"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, ButtonVariant, Checkbox, Input, Text, TextColor, TextSize, TextVariant } from "@workspace/ui/components";
// Form
import { Form, Formik } from "formik";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

// Context
import { useCustomer, useGlobal } from "@/context";
import validationSchema from "./validationSchema";
const SignUpForm = t0 => {
  const $ = _c(16);
  const {
    noRedirect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      unauthorized: false,
      customerAlreadyExists: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [status, setStatus] = useState(t1);
  const {
    signUp,
    getAccountInfo
  } = useCustomer();
  const {
    getGetResponseCheckSubscribedData
  } = useGlobal();
  const router = useRouter();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      email: "",
      password: "",
      passwordConfirmation: "",
      firstName: "",
      lastName: "",
      idGender: null,
      acceptTerms: false,
      newsletter: false
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialValues = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = validationSchema();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formSchema = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      unauthorized: "Nie uda\u0142o si\u0119 zarejestrowa\u0107 u\u017Cytkownika",
      customerAlreadyExists: "Konto dla tego adresu email ju\u017C istnieje"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const statusContent = t4;
  let t5;
  if ($[4] !== getAccountInfo || $[5] !== getGetResponseCheckSubscribedData || $[6] !== noRedirect || $[7] !== router || $[8] !== signUp || $[9] !== status) {
    t5 = (values, t6) => {
      const {
        setSubmitting,
        resetForm
      } = t6;
      signUp({
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        gender: values.idGender || 1
      }).then(resUser => {
        if (resUser.status === 308) {
          setSubmitting(false);
          setStatus({
            ...status,
            customerAlreadyExists: true
          });
        }
        if (resUser.status === 200) {
          getGetResponseCheckSubscribedData().then(() => {
            resetForm();
            setSubmitting(false);
            setStatus({
              unauthorized: false,
              customerAlreadyExists: false
            });
            toast.success("Konto zosta\u0142o utworzone");
            getAccountInfo().then(() => {
              if (!noRedirect) {
                router.push("/moje-konto");
              }
            });
          });
        }
      });
    };
    $[4] = getAccountInfo;
    $[5] = getGetResponseCheckSubscribedData;
    $[6] = noRedirect;
    $[7] = router;
    $[8] = signUp;
    $[9] = status;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== status) {
    t6 = t7 => {
      const {
        values: values_0,
        touched,
        errors,
        setFieldValue,
        isSubmitting
      } = t7;
      return <SignUpFormWrapper><HeaderWrapper><Text variant={TextVariant.H5} text={"Zarejestruj si\u0119"} color={TextColor.BLACK} /></HeaderWrapper>{Object.values(status).indexOf(true) > -1 && <InfoBar $error={status.unauthorized || status.customerAlreadyExists} $success={false}><Text variant={TextVariant.P} text={Object.values(statusContent)[Object.values(status).indexOf(true)]} color={TextColor.WHITE} /></InfoBar>}<FormWrapper><Input autoFocus={true} id="email" value={values_0.email} name="email" label="Adres email" placeholder={"Wprowad\u017A adres email"} focused={touched.email} validated={typeof errors.email === "undefined" && touched.email} error={typeof errors.email !== "undefined" && touched.email} errorHelper={errors.email} onChange={e => setFieldValue("email", e.target.value)} icon={false} type="text" autoComplete="off" /><div className="flex flex-row gap-2"><Input id="firstName" value={values_0.firstName} name="firstName" label={"Imi\u0119"} placeholder={"Wprowad\u017A imi\u0119"} focused={touched.firstName} validated={typeof errors.firstName === "undefined" && touched.firstName} error={typeof errors.firstName !== "undefined" && touched.firstName} errorHelper={errors.firstName} onChange={e_0 => setFieldValue("firstName", e_0.target.value)} icon={false} type="text" autoComplete="off" /><Input id="lastName" value={values_0.lastName} name="lastName" label="Nazwisko" placeholder={"Wprowad\u017A nazwisko"} focused={touched.lastName} validated={typeof errors.lastName === "undefined" && touched.lastName} error={typeof errors.lastName !== "undefined" && touched.lastName} errorHelper={errors.lastName} onChange={e_1 => setFieldValue("lastName", e_1.target.value)} icon={false} type="text" autoComplete="off" /></div><Input id="password" value={values_0.password} name="password" label={"Has\u0142o"} placeholder={"Wprowad\u017A has\u0142o"} focused={touched.password} validated={typeof errors.password === "undefined" && touched.password} error={typeof errors.password !== "undefined" && touched.password} errorHelper={errors.password} onChange={e_2 => setFieldValue("password", e_2.target.value)} icon={true} iconPosition="right" type="password" autoComplete="off" /><Input id="passwordConfirmation" value={values_0.passwordConfirmation} name="passwordConfirmation" label={"Potwierd\u017A has\u0142o"} placeholder={"Wprowad\u017A potwierdzenie has\u0142a"} focused={touched.passwordConfirmation} validated={typeof errors.passwordConfirmation === "undefined" && touched.passwordConfirmation} error={typeof errors.passwordConfirmation !== "undefined" && touched.passwordConfirmation} errorHelper={errors.passwordConfirmation} onChange={e_3 => setFieldValue("passwordConfirmation", e_3.target.value)} icon={false} type="password" autoComplete="off" /><div className="flex flex-col gap-2 items-start w-full mt-4 relative"><Text text={"P\u0142e\u0107"} color={TextColor.GRAYSCALE_600} /><div className="flex gap-2 justify-start items-start"><Checkbox id="idGender" name="idGender" label={"M\u0119\u017Cczyzna"} checked={values_0.idGender === 0} onChange={() => setFieldValue("idGender", 0)} /><Checkbox id="idGender" name="idGender" label="Kobieta" checked={values_0.idGender === 1} onChange={() => setFieldValue("idGender", 1)} /></div>{typeof errors.idGender !== "undefined" && touched.idGender && <ErrorFormHelperText><Text text={errors.idGender} color={TextColor.ERROR_500} fontSize={TextSize.XS} /></ErrorFormHelperText>}</div><div className="flex flex-col gap-2 items-start w-full relative mb-2"><Checkbox id="acceptTerms" name="acceptTerms" label="" labelHtml={"Zak\u0142adaj\u0105c konto akceptuj\u0119 <a href='/regulamin-sklepu' target='_blank'>Regulamin</a> oraz <a href='/polityka-prywatnosci' target='_blank'>Polityk\u0119 prywatno\u015Bci</a> CARRY. <span className='text-red-500'>*</span>"} checked={values_0.acceptTerms} onChange={() => setFieldValue("acceptTerms", !values_0.acceptTerms)} alignStart={true} />{typeof errors.acceptTerms !== "undefined" && touched.acceptTerms && <ErrorFormHelperText><Text text={errors.acceptTerms} color={TextColor.ERROR_500} fontSize={TextSize.XS} /></ErrorFormHelperText>}</div><div className="flex flex-col gap-2 items-start w-full relative mb-2"><Checkbox id="newsletter" name="newsletter" label="" labelHtml={"Chc\u0119 zapisa\u0107 si\u0119 do newslettera i otrzymywa\u0107 informacje o nowo\u015Bciach oraz o promocjach za pomoc\u0105 poczty elektronicznej. Mog\u0119 zrezygnowa\u0107 w ka\u017Cdej chwili."} checked={values_0.newsletter} onChange={() => setFieldValue("newsletter", !values_0.newsletter)} alignStart={true} /></div><ButtonsWrapper><Button type="submit" variant={ButtonVariant.PRIMARY} text={"Zarejestruj si\u0119"} disabled={isSubmitting} loading={isSubmitting} /></ButtonsWrapper></FormWrapper></SignUpFormWrapper>;
    };
    $[11] = status;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={t5}>{t6}</Formik>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
const ErrorFormHelperText = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  color: ${({
  theme
}) => theme.colors.ERROR_500} !important;
  line-height: 20px;
  text-align: right !important;
`;
const InfoBar = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  padding: 2px 10px;

  ${({
  theme,
  $error
}) => $error && `
    background-color: ${theme.colors.ERROR_400};
  `}

  ${({
  theme,
  $success
}) => $success && `
    background-color: ${theme.colors.GRAYSCALE_500};
  `}
`;
const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  .MuiFormGroup-root {
    margin-bottom: 0;
    margin-right: 16px;
    width: 100%;
  }

  button {
    width: 100%;
  }

  .MuiFormGroup-root {
    margin-bottom: 16px;
  }
`;
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  img {
    margin-bottom: 16px;
  }

  h5 {
    margin-bottom: 16px;
  }

  p {
    letter-spacing: 0.16px;
    margin-bottom: 24px;
  }
`;
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;
const SignUpFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 335px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    max-width: 100%;
  }
`;
export default SignUpForm;